import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import tableSlice from "components/elements/table/reducer/table.slice";
import formDrawerSlice from "../components/elements/formDrawer/formdrawer.slice";
import LoginSlice from "./reducers/LoginSlice";
import sidebarReducer from "./reducers/SidebarSlice";
import OrderSlice from "./reducers/OrderSlice";

const store = configureStore({
  reducer: {
    sideBarData: sidebarReducer,
    formDrawerState: formDrawerSlice,
    tableState: tableSlice,
    LoginState: LoginSlice,
    OrderState: OrderSlice,
    // reducers...
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export default store;
